import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@nykaa/nes-ui-components';
import Bar from './Bar';
import SearchBarV2 from './SearchBarV2';
import BackIcon from 'components/BackIcon';
import { State } from 'store/types';

const Wrapper = styled.div<{ customSpacing: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  position: sticky;
  top: 0;
  height: 60px;
  z-index: 1;
  padding: ${({ customSpacing, theme: { spacing } }) =>
    (customSpacing && `${spacing.spacing0} ${spacing.spacing100}`) ||
    spacing.spacing0};
`;

const Header = () => {
  const isNewSearchEnabled = useSelector(
    (state: State) => state.remoteConfig.switches.isNewSearchBarEnabled
  );

  if (isNewSearchEnabled) {
    return (
      <Wrapper customSpacing={isNewSearchEnabled}>
        <SearchBarV2 />
      </Wrapper>
    );
  }
  return (
    <Wrapper customSpacing={isNewSearchEnabled}>
      <BackIcon />
      <Bar />
    </Wrapper>
  );
};

export default Header;
